import {
  ICriarTabelaDebitosUseCase,
  ITabelaDebitosDataSource
} from "../ports/CriarTabelaDebitos";
import { inject, injectable } from "inversify";
import { ContabilDITypes } from "@/features/contabil/services/types";
import "reflect-metadata";
import TabelaDebitosDataSourceDTO from "./TabelaDebitosDataSourceDTO";
import { type IControleDebitosPorEmpresaGateway } from "../ports/ControleDebitosPorEmpresaGateway";

@injectable()
export default class CriarTabelaDebitosPorEmpresaUseCase
  implements ICriarTabelaDebitosUseCase
{
  @inject(ContabilDITypes.CONTROLE_DEBITOS_POR_EMPRESA_GATEWAY)
  private gateway!: IControleDebitosPorEmpresaGateway;

  async criarTabela(empresaId?: string): Promise<ITabelaDebitosDataSource[]> {
    if (empresaId == null) {
      return [];
    }

    const response = await this.gateway.get({ empresaId });

    if (response.isFailure) return [];

    return TabelaDebitosDataSourceDTO.execute([
      {
        debitos: response.getValue().debitos,
        empresa: response.getValue().empresa
      }
    ]);
  }
}
